export const getImageThumbnailWidth = (
  viewWidth: number,
  imageWidth?: number
): number => {
  const maxImageWidth = imageWidth || 320;

  return maxImageWidth >= viewWidth ? viewWidth : maxImageWidth;
};
